export const getFilterLabel = filter => {
  const label = filter.name === 'pmYear' ? 'Year' : filter.label;

  if (filter.type === 'number' && filter.operator) {
    const operatorSymbols = {
      eq: '=',
      gt: '>',
      gte: '≥',
      lt: '<',
      lte: '≤',
    };
    return `${label} ${operatorSymbols[filter.operator] || ''} ${filter.value}`;
  }

  if (filter.type === 'string' && filter.operator) {
    const operatorLabels = {
      contains: 'contains',
      startsWith: 'starts with',
      endsWith: 'ends with',
    };
    return `${label} ${operatorLabels[filter.operator] || ''} "${filter.value}"`;
  }

  return `${label}: ${filter.value}`;
};
